import { useSearchParams, useNavigate } from 'react-router-dom';
import LawyerStep2 from './LawyerStep2';
import LawyerFinalStep from './LawyerFinalStep';

export default function LawyerOnboardingWrapper() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  // 1. Get current step (Default to 2)
  const currentStep = Number(searchParams.get('step')) || 2;

  // 2. Navigation Handlers
  const handleNextStep = (nextStep: number) => {
    navigate(`?step=${nextStep}`);
    window.scrollTo(0, 0);
  };



  return (
    <div className="min-h-screen bg-brand-blue-900 py-12 px-4">
      <div className="max-w-3xl mx-auto space-y-6">
        
        {/* Progress Indicator */}
        <div className="bg-white rounded-lg shadow-xl p-6 mb-6">
          <div className="flex justify-between items-center max-w-md mx-auto">
            {[2, 3].map((step) => (
              <div key={step} className="flex flex-col items-center flex-1">
                <div
                  className={`w-10 h-10 rounded-full flex items-center justify-center font-semibold transition-colors duration-300 ${
                    step === currentStep
                      ? 'bg-cyan-400 text-white'
                      : step < currentStep
                      ? 'bg-green-500 text-white'
                      : 'bg-gray-300 text-gray-600'
                  }`}
                >
                  {step < currentStep ? '✓' : step - 1} 
                </div>
                <p className="text-xs mt-2 text-gray-600 font-medium">
                  {step === 2 && 'Verification'}
                  {step === 3 && 'Final Review'}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Render Active Step */}
        
        {currentStep === 2 && (
          <LawyerStep2 
            onNext={() => handleNextStep(3)} 
          />
        )}

        {currentStep === 3 && (
          <LawyerFinalStep 
        
          />
        )}

      </div>
    </div>
  );
}